@file:OptIn(InternalResourceApi::class)

package webproject.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/webproject.composeapp.generated.resources/"

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.icon_bg: DrawableResource by lazy {
      DrawableResource("drawable:icon_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_bg.jpg", -1, -1),
      ))
    }

internal val Res.drawable.icon_no: DrawableResource by lazy {
      DrawableResource("drawable:icon_no", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_no.png", -1, -1),
      ))
    }

internal val Res.drawable.icon_no01: DrawableResource by lazy {
      DrawableResource("drawable:icon_no01", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_no01.png", -1, -1),
      ))
    }

internal val Res.drawable.icon_no1: DrawableResource by lazy {
      DrawableResource("drawable:icon_no1", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_no1.png", -1, -1),
      ))
    }

internal val Res.drawable.icon_no2: DrawableResource by lazy {
      DrawableResource("drawable:icon_no2", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_no2.png", -1, -1),
      ))
    }

internal val Res.drawable.icon_no3: DrawableResource by lazy {
      DrawableResource("drawable:icon_no3", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_no3.png", -1, -1),
      ))
    }

internal val Res.drawable.icon_tousu: DrawableResource by lazy {
      DrawableResource("drawable:icon_tousu", setOf(
        ResourceItem(setOf(), "${MD}drawable/icon_tousu.png", -1, -1),
      ))
    }

internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.png", -1, -1),
      ))
    }

internal val Res.drawable.meiyoushuju: DrawableResource by lazy {
      DrawableResource("drawable:meiyoushuju", setOf(
        ResourceItem(setOf(), "${MD}drawable/meiyoushuju.png", -1, -1),
      ))
    }

internal val Res.drawable.paihangbang: DrawableResource by lazy {
      DrawableResource("drawable:paihangbang", setOf(
        ResourceItem(setOf(), "${MD}drawable/paihangbang.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("icon_bg", Res.drawable.icon_bg)
  map.put("icon_no", Res.drawable.icon_no)
  map.put("icon_no01", Res.drawable.icon_no01)
  map.put("icon_no1", Res.drawable.icon_no1)
  map.put("icon_no2", Res.drawable.icon_no2)
  map.put("icon_no3", Res.drawable.icon_no3)
  map.put("icon_tousu", Res.drawable.icon_tousu)
  map.put("logo", Res.drawable.logo)
  map.put("meiyoushuju", Res.drawable.meiyoushuju)
  map.put("paihangbang", Res.drawable.paihangbang)
}
